import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ColorVariant } from '@core/models';
import { BaseComponent } from '@core/utils';

@Component({
    selector: 'askemo-button',
    imports: [MatIcon],
    template: `
        <button
            class="askemo-btn {{ additionalClasses() }}"
            [disabled]="disabled()"
            [class.btn-primary]="variant() === 'primary'"
            [class.btn-secondary]="variant() === 'secondary'"
            [class.btn-link]="variant() === 'link'"
            [class.btn-icon]="variant() === 'icon'"
            [class.btn-xs]="size() === 'xs'"
            [class.btn-sm]="size() === 's'"
            [class.btn-m]="size() === 'm'"
            [class.btn-lg]="size() === 'l'"
            [class.btn-xxl]="size() === 'xxl'"
            [class.color-primary]="colorVariant() === 'primary'"
            [class.color-success]="colorVariant() === 'success'"
            [class.color-error]="colorVariant() === 'error'"
            [class.color-warning]="colorVariant() === 'warning'"
            [class.color-inactive]="colorVariant() === 'inactive'"
            [class.color-black]="colorVariant() === 'black'"
            [class.color-grey]="colorVariant() === 'grey'"
            [class.font-weight-medium]="fontWeight() === 'medium'"
            [class.font-weight-regular]="fontWeight() === 'regular'"
            [class.p-0]="!hasPadding()">
            @if (icon() || svgIcon()) {
                <mat-icon
                    class="{{ iconClass() }}"
                    [svgIcon]="svgIcon()">
                    {{ icon() }}
                </mat-icon>
            }
            <ng-content></ng-content>
        </button>
    `,
    styleUrl: './button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
    encapsulation: ViewEncapsulation.None
  })
export class ButtonComponent extends BaseComponent {
    public readonly variant = input<'primary' | 'secondary' | 'icon' | 'link'>('primary');
    public readonly fontWeight = input<'medium' | 'regular'>('medium');
    public readonly colorVariant = input<ColorVariant>('primary');
    public readonly size = input<'xs' | 's' | 'm' | 'l' | 'xxl'>('m');
    public readonly icon = input<string>();
    public readonly svgIcon = input<string>();
    public readonly iconClass = input<string>();
    public readonly disabled = input(false);
    public readonly hasPadding = input(true);
    public readonly additionalClasses = input<string>();
}
